export const isIOSDevice = (
  userAgent = typeof navigator === "undefined" ? "" : navigator.userAgent,
  maxTouchPoints = typeof navigator === "undefined"
    ? 0
    : navigator.maxTouchPoints
): boolean =>
  /iphone|ipad|ipod/i.test(userAgent) ||
  (/macintosh/i.test(userAgent) && maxTouchPoints > 1);
